export default __webpack_public_path__ + "media/color/dth-ae8002cd.svg";